export default "__VITE_ASSET__6f644704__"